import { Node } from "tiptap";

// Campo dinamico do termo de adesao: um "chip" atomico (nao editavel por dentro)
// gravado como <span data-placeholder="credor.nome">. O backend troca o span pelo
// valor real ao emitir o termo (PlanAdhesionPlaceholderHelper).
export default class PlaceholderNode extends Node {
  get name() {
    return "placeholder";
  }

  get schema() {
    return {
      inline: true,
      group: "inline",
      atom: true,
      selectable: true,
      draggable: true,
      attrs: {
        key: { default: null },
        label: { default: null },
      },
      parseDOM: [{
        tag: "span[data-placeholder]",
        getAttrs: (dom) => ({
          key: dom.getAttribute("data-placeholder"),
          label: dom.getAttribute("data-label") || dom.textContent.replace(/[{}]/g, ""),
        }),
      }],
      toDOM: (node) => [
        "span",
        {
          "data-placeholder": node.attrs.key,
          "data-label": node.attrs.label || node.attrs.key,
          class: "plan-adhesion-field",
          title: `{{${node.attrs.key}}}`,
        },
        node.attrs.label || node.attrs.key,
      ],
    };
  }

  commands({ type }) {
    return (attrs) => (state, dispatch) => {
      const { from, to } = state.selection;
      dispatch(state.tr.replaceWith(from, to, type.create(attrs)));
      return true;
    };
  }
}
